document.addEventListener('DOMContentLoaded', ()=> {

  const text = document.getElementById('text-counter')
  const dateInit = document.getElementById('date_init')?.innerText
  const dateEnd = document.getElementById('date_end')?.innerText

  function initCounter(dates) {
    let currentIndex = 0;
    function updateCounter() {
      const now = new Date().getTime();
      const endDate = dates[currentIndex];
      const timeLeft = endDate - now;
  
      if (timeLeft < 0) {
        if (currentIndex < dates.length - 1) {
          currentIndex++;
          text.innerText = 'La pre venta termina en:'
          updateCounter();
        } else {
          document.getElementById("days").innerHTML = '0';
          document.getElementById("hours").innerHTML = '0';
          document.getElementById("minutes").innerHTML = '0';
          document.getElementById("seconds").innerHTML = '0';
          clearInterval(interval);
        }
        return;
      }
  
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      if(document.getElementById("days") && document.getElementById("hours") && document.getElementById("minutes") && document.getElementById("seconds")){
        document.getElementById("days").innerHTML = `${days}`;
        document.getElementById("hours").innerHTML = `${hours}`;
        document.getElementById("minutes").innerHTML = `${minutes}`;
        document.getElementById("seconds").innerHTML = `${seconds}`;
      }
    }
  
    updateCounter();
      const interval = setInterval(updateCounter, 1000);
    }
  
  const dates = [
    new Date(dateInit).getTime(),
    new Date(dateEnd).getTime()
  ];
  
  initCounter(dates);
})